if (!customElements.get('expandable-description')) {
  customElements.define(
    'expandable-description',
    class ExpandableDescription extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.details = this.querySelector('details');
        this.summary = this.querySelector('summary');
        this.body = this.querySelector('.product-details__body');
        this.content = this.querySelector('[data-expandable-content]');
        this.toggleButton = this.querySelector('[data-expandable-toggle]');
        this.labelMore = this.toggleButton?.querySelector('[data-label-more]');
        this.labelLess = this.toggleButton?.querySelector('[data-label-less]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.animating = false;

        if (!this.content || !this.toggleButton) return;

        this.collapsedPx = this.content.clientHeight;
        this.onToggle = this.onToggle.bind(this);
        this.onSummaryClick = this.onSummaryClick.bind(this);
        this.updateOverflow = this.updateOverflow.bind(this);

        this.toggleButton.addEventListener('click', this.onToggle);
        this.summary?.addEventListener('click', this.onSummaryClick);
        window.addEventListener('resize', this.updateOverflow);
        this.updateOverflow();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.updateOverflow);
      }

      onSummaryClick(event) {
        event.preventDefault();
        if (this.animating || !this.details || !this.body) return;

        if (this.details.open) {
          this.animateBox(this.body, this.body.scrollHeight, 0, () => {
            this.details.open = false;
            this.body.style.height = '';
            this.body.style.overflow = '';
          });
        } else {
          this.details.open = true;
          this.animateBox(this.body, 0, this.body.scrollHeight, () => {
            this.body.style.height = '';
            this.body.style.overflow = '';
            this.updateOverflow();
          });
        }
      }

      onToggle() {
        if (this.animating) return;

        const expanded = !this.classList.contains('is-expanded');
        this.classList.toggle('is-expanded', expanded);
        this.toggleButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        if (this.labelMore) this.labelMore.hidden = expanded;
        if (this.labelLess) this.labelLess.hidden = !expanded;

        const start = this.content.getBoundingClientRect().height;
        const end = expanded ? this.content.scrollHeight : this.collapsedPx;

        this.animateBox(this.content, start, end, () => {
          if (expanded) {
            this.content.style.height = 'auto';
            this.content.style.overflow = 'visible';
          } else {
            this.content.style.height = '';
            this.content.style.maxHeight = 'var(--collapsed-height)';
            this.content.style.overflow = 'hidden';
            this.updateOverflow();
          }
        });
      }

      animateBox(element, from, to, done) {
        if (this.reducedMotion || from === to) {
          done();
          return;
        }

        this.animating = true;
        element.style.maxHeight = 'none';
        element.style.overflow = 'hidden';
        element.style.height = `${from}px`;
        element.offsetHeight;
        element.style.transition = 'height 0.45s cubic-bezier(0.22, 1, 0.36, 1)';
        element.style.height = `${to}px`;

        const onEnd = (event) => {
          if (event.target !== element || event.propertyName !== 'height') return;
          element.removeEventListener('transitionend', onEnd);
          element.style.transition = '';
          this.animating = false;
          done();
        };

        element.addEventListener('transitionend', onEnd);
      }

      updateOverflow() {
        if (this.classList.contains('is-expanded')) {
          this.toggleButton.hidden = false;
          return;
        }

        const needsToggle = this.content.scrollHeight > this.content.clientHeight + 1;
        this.toggleButton.hidden = !needsToggle;
      }
    }
  );
}
